export default "__VITE_ASSET__29c23018__"